import api from "dao/providers/axios";
import appconfig from "config/appconfig";
import environment from "lib/environment";

const roleBaseUrl= { baseURL: environment.get().api.portalURL };
const scopeManagementEndpoint = appconfig.endpoints.oAuthScopesManagement;

export const daoScopeListGet = () => api.get(scopeManagementEndpoint,roleBaseUrl);

export const daoScopePost = (payload) => api.post(scopeManagementEndpoint, payload,roleBaseUrl);

export const daoGetScopeById = (roleId) => api.get(`${scopeManagementEndpoint}/${roleId}`, roleBaseUrl);

export const daoScopePatch = (roleId, payload) => api.patch(`${scopeManagementEndpoint}/${roleId}`, payload, roleBaseUrl);

export const daoScopeApproversGet = (roleId) => api.get(`${scopeManagementEndpoint}/${roleId}/approvers`,roleBaseUrl);

export const daoScopeApproversPut = (roleId,approver,payload) => api.put(`${scopeManagementEndpoint}/${roleId}/approvers/${approver}`,payload, roleBaseUrl);

export const daoScopeApproversDelete = (roleId,approver) => api.delete(`${scopeManagementEndpoint}/${roleId}/approvers/${approver}`, roleBaseUrl);
